module.exports = __webpack_public_path__ + "static/media/mm.386487d6.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/mm.svg
// module id = 927
// module chunks = 0